<template>
    <div class="custom-line-chart">
        <canvas ref="chartCanvas" :width="width" :height="height"></canvas>
    </div>
</template>

<script>
import Chart from 'chart.js'

export default {
    name: 'CustomLineChart',
    props: {
        chartData: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            default: () => ({})
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 200
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        chartData: {
            handler(newData) {
                this.updateChart()
            },
            deep: true
        },
        options: {
            handler(newOptions) {
                this.updateChart()
            },
            deep: true
        }
    },
    mounted() {
        this.renderChart()
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy()
        }
    },
    methods: {
        renderChart() {
            if (!this.$refs.chartCanvas) {
                return
            }

            // Уничтожаем предыдущий график если есть
            if (this.chart) {
                this.chart.destroy()
            }

            const ctx = this.$refs.chartCanvas.getContext('2d')
            
            this.chart = new Chart(ctx, {
                type: 'line',
                data: this.chartData,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    ...this.options
                }
            })
        },
        updateChart() {
            if (this.chart) {
                this.chart.data = this.chartData
                this.chart.options = {
                    ...this.chart.options,
                    ...this.options
                }
                this.chart.update()
            } else {
                this.renderChart()
            }
        }
    }
}
</script>

<style scoped>
.custom-line-chart {
    position: relative;
    width: 100%;
    height: 100%;
}
</style>
